import { PersonsInvoiceElementsService_personInvoiceElementsServiceGetGetInvoiceElements } from '@festina/moneyin-general-types/moneyin/hooks/PersonsInvoiceElementsService_personInvoiceElementsServiceGetGetInvoiceElements'

export const useFetchPersonInvoiceElements =
  PersonsInvoiceElementsService_personInvoiceElementsServiceGetGetInvoiceElements.useSuspenseQuery
